(() => {
  if (window.hydeRenderZoomInstalled) return;
  window.hydeRenderZoomInstalled = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-render-zoom]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const section = link.closest('.shopify-section') || document;
    const dialog = section.querySelector('.render-dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    const stage = dialog.querySelector('.render-stage');
    const toggle = dialog.querySelector('[data-zoom-toggle]');
    const title = dialog.querySelector('h2');
    const image = new Image();
    image.alt = link.dataset.name;
    image.src = link.href;
    image.className = 'render-original';
    image.decoding = 'async';
    stage.replaceChildren(image);
    stage.classList.remove('is-zoomed');
    title.textContent = link.dataset.name;
    toggle.textContent = toggle.dataset.zoomLabel;
    toggle.setAttribute('aria-pressed', 'false');
    toggle.onclick = () => {
      const zoomed = stage.classList.toggle('is-zoomed');
      toggle.textContent = zoomed ? toggle.dataset.fitLabel : toggle.dataset.zoomLabel;
      toggle.setAttribute('aria-pressed', String(zoomed));
      stage.scrollTo({left: zoomed ? (stage.scrollWidth - stage.clientWidth) * 0.7 : 0, top: zoomed ? (stage.scrollHeight - stage.clientHeight) * 0.65 : 0, behavior: 'instant'});
    };
    dialog.querySelector('[data-render-close]').onclick = () => dialog.close();
    dialog.onclick = e => { if (e.target === dialog) dialog.close(); };
    dialog.onclose = () => { document.documentElement.classList.remove('render-open'); link.focus({preventScroll:true}); };
    document.documentElement.classList.add('render-open');
    dialog.showModal();
  });
})();
